import { render, staticRenderFns } from "./TestoneMain.vue?vue&type=template&id=4d513f6c"
import script from "./TestoneMain.vue?vue&type=script&lang=js"
export * from "./TestoneMain.vue?vue&type=script&lang=js"
import style0 from "./TestoneMain.vue?vue&type=style&index=0&id=4d513f6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports